import React, { Component } from 'react';
import SubmitModal from './SubmitModal';
import EditGenres from './EditGenres';
import Chord from './Chord';
import jQuery from 'jquery';

class SongEditForm extends Component{
  constructor(props){
    super(props);
    this.state={
      editgenres:false,
      submitted:false,
      genrearray:[],
      chords:[]
    }
  }
  submit(e){
    e.preventDefault();
    if(this.state.uid ===''){
      this.setState({
        submitted:true,
        modaltext:'You gotta log in first.'
      });
      return;
    }
    let title= this.refs.title.value;
    let lyrics= this.refs.lyrics.value;
    let artist= this.refs.artist.value;
    let genres = this.state.genrearray;
    let chords = this.state.chords;
    this.props.submit(title,lyrics,artist,genres,chords);
  }
  componentWillMount(){
    console.log('moods: ',this.props.genres);
    let data = this.props.genres;
    let moods = data.map((val)=>{
      return (
        <button className=" btn-primary">{val}</button>
      );
    });
    this.setState({
      moods:moods,
      genrearray:data,
      chords:this.props.chords
    });
  }
  editGenres(e){
    e.preventDefault();
    this.setState({
      editgenres:true
    });
  }
  cancelGenreEdit(){
    this.setState({
      editgenres:false
    });
  }
  hideModal(){
    this.setState({
      submitted:false
    });
  }
  updateGenres(genres){
    console.log('updating genres to: ',genres);
    this.setState({
      genrearray:genres
    })
  }
  showChord(e){
      e.preventDefault();
      const hider = jQuery('.chord_hider');

      if(hider.css('opacity')==='0'){
        jQuery('.chord_hider').animate({'opacity':'1','height':'400'},650);
      }else{
        jQuery('.chord_hider').animate({'opacity':'0','height':'0'},450);
      }
    }
  saveChord(chord){
    const chords = this.state.chords;
    chords.push(chord);
    console.log('chords: ',chords);
    this.setState({
      submitted:true,
      chords,
      modaltext:'Yeahh.'
    });
  }
  missingName(){
    this.setState({
      submitted:true,
      modaltext:'Name your chord, baby.'
    });
  }
 render(){
    let please_login = (this.state.submitted) ? (<SubmitModal text={this.state.modaltext} hide={this.hideModal.bind(this)}/>) : '';
    let moods = this.state.moods;
    let genrearray = this.state.genrearray;
    let currentgenres = genrearray.join(', ');
    let genres = (this.state.editgenres) ? (<EditGenres cancel={this.cancelGenreEdit.bind(this)} updateGenres = {this.updateGenres.bind(this)} genrearray={genrearray} moods={moods} />)
    :(<button onClick={this.editGenres.bind(this)} className="btn  btn-primary">Edit Genres</button>);

    return(
      <div className="song-update-form">
      <form id={this.props.id} onSubmit={this.submit.bind(this)} className="song-edit-form form form-default">
          {/* <div className="song-btn-row"> */}
            <div>
              <button type="submit" className="btn btn-success song-close">Submit</button>
              <button onClick={()=>this.props.cancel()} className="btn song-btn song_edit_btn song-close">Cancel</button>
            </div>
          {/* </div> */}
        <div>
          Genres: {currentgenres}
        </div>
        {genres}
        <div className="custom_chord_wrapper">
          <label>Add Custom Chords <button onClick={this.showChord.bind(this)} className="btn add_chord fa fa-angle-down"></button></label>
          <div className="chord_hider">
            <Chord missingName={this.missingName.bind(this)} saveChord={this.saveChord.bind(this)}/>
          </div>
        </div>
        <input ref="title" className="form-control" defaultValue={this.props.title} />
        <input ref="artist" className="form-control" defaultValue={this.props.artist}/>
        <textarea ref="lyrics" className="form-control song-edit-text" defaultValue=
          {this.props.lyrics} />
        <button type="submit" className="btn  btn-success">Submit</button>
        <br></br>
        <br></br>
      </form>
      {please_login}
      </div>
    );
  }
}

export default SongEditForm;



// WEBPACK FOOTER //
// ./src/components/SongEditForm.js